/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsGetOrg } from "../../funcs/budgetsGetOrg.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetOrgBudgetsRequest$inboundSchema,
};

export const tool$budgetsGetOrg: ToolDefinition<typeof args> = {
  name: "budgets-get-org",
  description: `List org budgets

Returns the org's budgets (self-budget and/or ceiling) with each one's live spend gauge. Targets the caller's own organization (inferred from the API key or session) unless the optional org_id query parameter names another org — cluster admins only.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsGetOrg(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
